import React from "react";
import { Button, Col, FormGroup, Label } from "reactstrap";
import LoadingContent from "../../../../components/LoadingContent/LoadingContent";
import useLazyFetch from "../../../../hooks/useLazyFetch";
import { USER_ACCOUNT_BANK_DELETE } from "../../../../redux/config/links";

const WithdrawalSettingsDelete = ({
  initialValues,
  onClose = () => null,
  onReload = () => null,
}) => {
  const [deleteBankAccount, { loading }] = useLazyFetch({
    url: USER_ACCOUNT_BANK_DELETE,
    method: "POST",
    type: "json",
  });
  return (
    <div className="container">
      <FormGroup row>
        <Col xs="12" md="12">
          <Label htmlFor="text-input">
            Do you want to delete this Bank Account?{" "}
          </Label>
        </Col>
      </FormGroup>
      <LoadingContent loading={loading}>
        <div>
          <Button
            onClick={() => {
              deleteBankAccount({ body: {id: initialValues.id} }, () => {
                onReload();
                onClose();
              });
            }}
            size="sm"
            color="danger"
            disabled={loading}
          >
            <i className="fa fa-trash"></i> Submit
          </Button>
          <Button
            onClick={() => onClose()}
            size="sm"
            color="success"
            disabled={loading}
          >
            <i className="fa fa-window-close"></i> Close
          </Button>
        </div>
      </LoadingContent>
    </div>
  );
};

export default WithdrawalSettingsDelete;
